module.exports = __webpack_public_path__ + "media/images/feature-icons/feature-icon-1-502fddd85763713e2a1d964b7adb55cb.svg";